import { Badge } from "@chakra-ui/react";

const colors: Record<string, string> = {
  Paid: "green", Pending: "orange", Overdue: "red", PartiallyPaid: "blue", Draft: "gray", Cancelled: "gray",
};

export default function StatusBadge({ status }: { status: string }) {
  return <Badge colorScheme={colors[status] ?? "gray"}>{status.replace(/([A-Z])/g, " $1").trim()}</Badge>;
}